import profil1Img from '@/assets/images/members/profil-chan.jpg'
import profil2Img from '@/assets/images/members/profil-darian.jpg'
import profil3Img from '@/assets/images/members/profil-swcomposer.jpg'
import profil4Img from '@/assets/images/members/profil-kimeshan.jpg'
import profil5Img from '@/assets/images/members/profil-vic.png'
import profil6Img from '@/assets/images/members/profil-braydon.jpg'
import profil7Img from '@/assets/images/members/profil-jay.jpeg'
import profil8Img from '@/assets/images/members/profil-keegan.jpeg'
import profil9Img from '@/assets/images/members/profil-1.png'
import profil10Img from '@/assets/images/members/profil-vic.png'
import profil11Img from '@/assets/images/members/profil-krishna.png'

const DATA = [
  {
    url: profil1Img.src,
    username: 'chan',
    tag: '@chan_slowgrowth',
    text: 'Used to be Obsidian for years, but I recently switched over to Lazy<br/><br/> For its quick capture, GPT integration (still testing a prompt summarizing my day. And the voice input on the mobile app, as an ADHDer, I found talking is sometimes easier than typing.',
  },
  {
    url: profil2Img.src,
    username: 'Darian Rosebrook',
    tag: '@darianrosebrook',
    text: "This tool has been so great in helping me with design research and content planning. Can't thank their team enough for getting to preview this tool early on.",
  },
  {
    url: profil3Img.src,
    username: 'Sebastian Watzinger',
    tag: '@SWComposer',
    text: '"⌘ L" - my absolute favorite shortcut! <br/><br/><br/><br/>',
  },
  {
    url: profil4Img.src,
    username: 'Kimeshan Naidoo',
    tag: '@kimeshan_n',
    text: "Lazy is my new favourite app.<br/> Think Superhuman meets Roam meets Asana.<br/> There's always been this missing link between note taking and task management, and Lazy is solving this.<br/>Still early days, but I predict it will be a beast of a commany -  will become a unicorn easily as long as the product keeps improving at pace.",
  },
  {
    url: profil5Img.src,
    username: 'Vuk Andric',
    tag: '@vukandric',
    text: 'I just tried <span>@lazyappHQ</span>, and all I can say is that I am more than impressed and that I am looking forward to using this gem in the future!<br/><br/>',
  },
  {
    url: profil6Img.src,
    username: 'Braydon Coyer',
    tag: '@BraydonCoyer',
    text: "I recently gained access to <span>@lazyappHQ</span>, and I must say, I'm already enamored with its seamless functionality for adding notes to clipped content such as articles and videos. The process is frictionless, allowing me to stay within the same context without context switching. It's a beautiful app 😍",
  },
  {
    url: profil7Img.src,
    username: 'Jay',
    tag: '@SaneInsane_',
    text: "Been using Lazy recently, and I must say that it's quite an impressive tool.<br/>You’re in the middle of a busy day, and inspiration hits you out of nowhere. You quickly jot it down without losing focus and get right back to what you were doing. Later, when the time is right, that idea is there waiting for you, perfectly preserved and ready to take shape. That’s Lazy. so, and trust me, it’s a lifesaver.",
  },
  {
    url: profil8Img.src,
    username: 'Keegan J. Sard',
    tag: '@keegansard',
    text: 'I recently started using Lazy and it’s quickly become one of my favorite tools for note-taking and organizing ideas. It’s not just about storing information—it feels like having a second brain that works with me to keep everything clear and accessible.',
  },
  {
    url: profil9Img.src,
    username: 'Shomik Ghosh',
    tag: '@shomikghosh21',
    text: 'Playing w/ <span>@lazyappHQ</span> beta & have to say it is quickly becoming a daily part of my workflow! Easiest way to capture quotes, context, articles, tweets all in an intuitive inbox format with a connected graph underlying it all to link concepts & ideas.',
  },
  {
    url: profil10Img.src,
    username: 'Vic Montano',
    tag: '@thevicmontano',
    text: '<span>@lazyappHQ</span> If you want to boost your digital content capture process and the organization of your second brain! 🔥<br /><br /><br />',
  },
  {
    url: profil11Img.src,
    username: 'KRISHNA AR',
    tag: '@krishnaar21',
    text: 'Recently onboarded to try out <span>@lazyappHQ</span> pretty much solves most of note taking problems from multiple sources.<br /><br /><br />',
  },
]

export default DATA
